import { Tooltip, TooltipContent, TooltipTrigger } from '@/comps/primitives/tooltip';
import { cn } from '@/utils/shad';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { Info } from 'lucide-react';
import { PropsWithChildren, useMemo, useState } from 'react';
import { WithClassName, WithOnClick } from '@/types/component';
import { PopperContentProps } from '@radix-ui/react-popper';

type TooltipButtonPros = PropsWithChildren<
  WithOnClick &
    WithClassName & {
      content: React.ReactNode;

      delay?: number;
      enabled?: boolean;
      side?: PopperContentProps['side'];
      align?: PopperContentProps['align'];
    }
>;

export const TooltipButton = ({
  content,
  children,
  delay = 0,
  enabled = true,
  className,
  side = 'bottom',
  align = 'center',
}: TooltipButtonPros) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip delayDuration={delay} open={open} onOpenChange={(o) => (enabled ? setOpen(o) : null)}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        align={align}
        side={side}
        className={cn('white z-50 block max-h-50 wrap-break-word whitespace-normal', className)}
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
};

export const QuestionMarkToolTip = (props: {
  content: React.ReactNode;
  className?: string;
  tooltipClassName?: string;
  kind?: 'questionMark' | 'info';
  side?: 'bottom' | 'left' | 'right';
}) => {
  const Icon = useMemo(() => (props.kind === 'info' ? Info : QuestionMarkCircledIcon), [props.kind]);

  return (
    <TooltipButton content={props.content} side={props.side ?? 'bottom'} className={props.tooltipClassName}>
      <Icon className={cn('inline h-base w-base text-muted-foreground hover:cursor-pointer', props.className)} />
    </TooltipButton>
  );
};
